import React from "react";
import clsx from "clsx";
export var ItemText = function (_a) {
    var className = _a.className, label = _a.label, subtitle = _a.subtitle, isBold = _a.isBold, useAltColors = _a.useAltColors;
    var baseClass = clsx("block text-sm whitespace-pre-wrap", {
        "text-text-primary": !useAltColors,
        "text-white": useAltColors,
        "font-semibold": isBold,
    });
    var itemClass = clsx(className, baseClass);
    var labelText = label ? label.trim() : null;
    return (React.createElement("p", { className: itemClass, "data-testid": "item-text" },
        labelText,
        subtitle && React.createElement("span", { className: "block font-normal" }, subtitle)));
};
//# sourceMappingURL=ItemText.js.map